/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import {
  ModalBodyProps,
  PaginatedListProps,
  QuickLinksTabsProps,
  RenderBodyContentProps,
  tabs,
  TabTypeSelectionProps,
  typeSelectionForForm,
} from './linkModalInterface';
import DropDownComponent from '../../utils/dropDown';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Search from '../../utils/typeSearch';
import { ReactComponent as LinkIcon } from '../../editor/editorFormattingIcons/linkButton.svg';
import { ReactComponent as GreaterIcon } from '../../editor/editorFormattingIcons/greaterIcon.svg';
import { ReactComponent as LesserIcon } from '../../editor/editorFormattingIcons/lesserIcon.svg';
import { ReactComponent as FilterIcon } from '../../editor/editorFormattingIcons/filterIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { ParentDataInterface } from '../../../redux/parentDataSlice';
import { handlingQuicklinks } from './utils';
import TableSkeleton from '../../editor/editorUtilityFunctions/skeletonLoader';
import { setSectionId, buttonFormError } from '../../../redux/button/button';
import { ReactComponent as ExclamationIcon } from '../../../assets/icons/exclamation.svg';

export const ModalBody: React.FC<ModalBodyProps> = ({
  setActiveTab,
  activeTab,
  setSelectedTypeTabOpen,
  selectedTypeTabOpen,
  setSelectedDirection,
  selectedDirection,
  setSelectedLink,
  selectedLink,
  type,
}) => {
  const [courseLinkTypeSelection, setCourseLinkTypeSelection] = useState<string[]>(['Modules']);
  return (
    <div className='modalBodyWrapper h-100'>
      <QuickLinksTabs
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        type={type}
        setSelectedLink={setSelectedLink}
        setSelectedTypeTabOpen={setSelectedTypeTabOpen}
      />
      <RenderBodyContent
        activeTab={activeTab}
        setSelectedTypeTabOpen={setSelectedTypeTabOpen}
        selectedTypeTabOpen={selectedTypeTabOpen}
        setSelectedDirection={setSelectedDirection}
        selectedDirection={selectedDirection}
        setCourseLinkTypeSelection={setCourseLinkTypeSelection}
        courseLinkTypeSelection={courseLinkTypeSelection}
        setSelectedLink={setSelectedLink}
        selectedLink={selectedLink}
      />
    </div>
  );
};
export const QuickLinksTabs: React.FC<QuickLinksTabsProps> = ({
  setActiveTab,
  activeTab,
  type,
  setSelectedLink,
  setSelectedTypeTabOpen,
}) => {
  const dispatch = useDispatch();
  const errors = useSelector((state: any) => state.button.errors);
  return (
    <div className='d-flex justify-content-start align-items-center gap-1'>
      {tabs
        .filter((tab) => !(type === 'button' && tab.key === 'email'))
        .map((tab) => (
          <button
            key={tab.key}
            type='button'
            aria-pressed={activeTab === tab.key}
            className={`linkTypeLabel ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => {
              setSelectedTypeTabOpen('new');
              let fail = { ...errors };
              delete fail['webAddress'];
              delete fail['email'];
              dispatch(buttonFormError({ errors: { ...fail } }));
              setSelectedLink(null);
              setActiveTab(tab.key);
              dispatch(buttonFormError({ errors: fail }));
            }}
          >
            {tab.label}
          </button>
        ))}
    </div>
  );
};

export const RenderBodyContent: React.FC<RenderBodyContentProps> = ({
  activeTab,
  setSelectedTypeTabOpen,
  selectedTypeTabOpen,
  setSelectedDirection,
  selectedDirection,
  setCourseLinkTypeSelection,
  courseLinkTypeSelection,
  setSelectedLink,
  selectedLink,
}) => {
  const [selectedType, setSelectedType] = useState('Modules');
  const [searchText, setSearchText] = useState('');
  const [isSearchText, setIsSearchText] = useState(false);
  const dataFromParent = useSelector((state: ParentDataInterface) => state.parentData.data);
  const [courseLinkData, setCourseLinkData] = useState<any>([]);
  const [selectedFilter, setSelectedFilter] = useState<string>('recent');
  const [isLoading, setIsLoading] = useState(true);
  const [pageNo, setPageNo] = useState<number>(1);
  const [isNextPage, setIsNextPage] = useState(false);
  const [pageNoCollaction, setPageNoCollaction] = useState<number[]>([1]);
  const [items, setItems] = useState<any[][]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [response, setResponse] = useState<any>({});
  const dispatch = useDispatch();
  const errors = useSelector((state: any) => state.button.errors);
  const [isApiCall, setisApiCall] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      if (!isApiCall) return;
      setIsNextPage(false);
      setIsLoading(true);
      const data = await handlingQuicklinks(
        selectedType,
        selectedFilter,
        searchText,
        pageNo,
        dataFromParent.env,
        dataFromParent.courseId,
        controller.signal,
      );
      if (!data) {
        setIsLoading(true);
        return;
      }
      setCourseLinkData(data.body || []);
      setIsNextPage(data.nextPage);
      setResponse(data);
      setIsLoading(false);
    };
    fetchData();
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedType, selectedFilter, searchText, pageNo]);
  const handleSearch = (text: string) => {
    setItems([]);
    setPageNoCollaction([1]);
    setPageNo(1);
    setCourseLinkTypeSelection([selectedType]);
    setSearchText(text);
    setSelectedLink(null);
    setisApiCall(text.trim().length !== 1);
  };

  const handleWebaddressOrEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    typeofInput: string,
  ) => {
    const value = event.target.value.trim();
    setSelectedLink(value ? { [typeofInput === 'email' ? 'email' : 'webAddress']: value } : null);
    const error = { ...errors };
    delete error[typeofInput];
    dispatch(
      buttonFormError({
        errors: { ...error },
      }),
    );
  };
  const updateFilter = ['Modules', 'Assignments', 'Quizzes'].includes(selectedType);
  return (
    <>
      <div className={`courselinkWrapper ${activeTab === 'courselinks' ? '' : 'd-none'}`}>
        <div className='d-flex justify-content-between align-items-center mt-3 filterWrapperLink'>
          <div className='d-flex justify-content-start align-items-center gap-2'>
            <p className='selectFormLabel'>Select from:</p>
            <Form.Group className='px-2 interactive-dropdown-container' id='interactiveDropdown'>
              <DropDownComponent
                setSelectedOption={(e: string) => {
                  setItems([]);
                  setCourseLinkTypeSelection([...courseLinkTypeSelection, e]);
                  setPageNoCollaction([1]);
                  setPageNo(1);
                  setSelectedType(e);
                  setSelectedLink(null);
                  setisApiCall(true);
                }}
                selectedOption={selectedType}
                className='lint-dropdown'
                optionCollection={typeSelectionForForm}
                type='filter'
              />
              <div className='arrow-down' />
            </Form.Group>
          </div>
          {selectedType !== 'Course Navigation' && (
            <div className='d-flex justify-content-end searchAndFilter'>
              <div
                className={`searchAndFilterWrapper ${!isSearchText ? 'withSearchText' : ''}`}
                style={{
                  width: !updateFilter ? '75%' : '100%',
                }}
              >
                <Search
                  initialvalue={searchText}
                  onChange={handleSearch}
                  isSearchText={isSearchText}
                  setIsSearchText={setIsSearchText}
                />
                {isSearchText && (
                  <em className='noteForSearch'>Note: 2 or more characters required</em>
                )}
              </div>
              {!updateFilter && (
                <div className='d-flex justify-content-end'>
                  <Dropdown
                    className='dropDownForFilter'
                    onSelect={(eventKey) => {
                      setItems([]);
                      setPageNoCollaction([1]);
                      setPageNo(1);
                      setCourseLinkTypeSelection([selectedType]);
                      setSelectedFilter(eventKey!);
                      setSelectedLink(null);
                      setisApiCall(true);
                    }}
                  >
                    <Dropdown.Toggle
                      as={Button}
                      variant='outline-secondary'
                      size='sm'
                      className='DropDownBTn'
                      data-testid='dropdownForFilter'
                    >
                      <FilterIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align='end'>
                      <Dropdown.Item eventKey='recent' active={selectedFilter === 'recent'}>
                        Recent
                      </Dropdown.Item>
                      <Dropdown.Item eventKey='asc' active={selectedFilter === 'asc'}>
                        Ascending
                      </Dropdown.Item>
                      {!['Discussions', 'Announcements'].includes(selectedType) && (
                        <Dropdown.Item eventKey='desc' active={selectedFilter === 'desc'}>
                          Descending
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
          )}
        </div>
        <div className='w-100 courseLinkList'>
          <PaginatedList
            modules={courseLinkData}
            setPageNo={setPageNo}
            isNextPage={isNextPage}
            pageNo={pageNo}
            isLoading={isLoading}
            courseLinkTypeSelection={courseLinkTypeSelection}
            selectedType={selectedType}
            setCourseLinkTypeSelection={setCourseLinkTypeSelection}
            setPageNoCollaction={setPageNoCollaction}
            pageNoCollaction={pageNoCollaction}
            setItems={setItems}
            items={items}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            setCurrentItems={setCurrentItems}
            currentItems={currentItems}
            response={response}
            setSelectedLink={setSelectedLink}
            selectedLink={selectedLink}
            setisApiCall={setisApiCall}
          />
          <div className='directionWrapper'>
            <label className='rediectRadio'>
              <input
                type='radio'
                name='chooseRadioButtonForRedirect'
                value='Redirect'
                checked={selectedDirection === 'Redirect'}
                onChange={() => setSelectedDirection('Redirect')}
              />{' '}
              Re-direct to the page
            </label>
            <label className='rediectRadio'>
              <input
                type='radio'
                name='chooseRadioButtonForRedirect'
                value='Specific'
                checked={selectedDirection === 'Specific'}
                onChange={() => setSelectedDirection('Specific')}
              />{' '}
              Go to specific section
            </label>
            <input
              placeholder='Type Section ID'
              className='sectionIdInput'
              disabled={selectedDirection !== 'Specific'}
              onChange={(e) => {
                dispatch(setSectionId({ sectionId: e.target.value }));
              }}
            />
            <div className='divider' />
            {activeTab === 'courselinks' && (
              <TabTypeSelection
                setSelectedTypeTabOpen={setSelectedTypeTabOpen}
                selectedTypeTabOpen={selectedTypeTabOpen}
              />
            )}
          </div>
        </div>
      </div>
      {activeTab === 'webaddress' && (
        <div className='mt-3'>
          <div className='mb-2 weblinkWrapperTitle'>
            Type/Paste Your Web Address Below <span className='starColor'>*</span>
          </div>
          <div className={`weblinkWrapper ${errors?.webAddress ? 'invalid-webaddress' : ''}`}>
            <LinkIcon className='mr-2' />
            <input
              type='url'
              className='webadderssInput'
              placeholder='eg: https://soaringed.com'
              onChange={(e) => handleWebaddressOrEmailChange(e, 'webAddress')}
            />
          </div>
          {errors?.webAddress && (
            <div className='error-text'>
              <ExclamationIcon height={12} width={12} />{' '}
              <Form.Text> Enter a valid web address</Form.Text>{' '}
            </div>
          )}
          <hr />
          <TabTypeSelection
            setSelectedTypeTabOpen={setSelectedTypeTabOpen}
            selectedTypeTabOpen={selectedTypeTabOpen}
          />
        </div>
      )}
      {activeTab === 'email' && (
        <>
          <div className='mt-3'>
            <div className='emailLabel mb-2'>
              Enter email address below <span className='starColor'>*</span>
            </div>
            <input
              className={`emailInput ${errors?.email ? 'invalid-email' : ''}`}
              type='email'
              placeholder='eg:example@soaringed.com'
              onChange={(e) => handleWebaddressOrEmailChange(e, 'email')}
            />{' '}
          </div>
          {errors?.email && (
            <div className='error-text'>
              <ExclamationIcon height={12} width={12} />{' '}
              <Form.Text> Enter a valid email address</Form.Text>{' '}
            </div>
          )}
        </>
      )}
    </>
  );
};
export const TabTypeSelection: React.FC<TabTypeSelectionProps> = ({
  setSelectedTypeTabOpen,
  selectedTypeTabOpen,
}) => {
  return (
    <div className='tab-type-selection'>
      <div className='typeSelectionLabel mb-2'>How do you want to open?</div>
      <div className='tabRadioWrapper'>
        <label className='tabRadio'>
          <input
            type='radio'
            name='chooseRadioButton'
            value='new'
            checked={selectedTypeTabOpen === 'new'}
            onChange={() => setSelectedTypeTabOpen('new')}
          />{' '}
          New Tab
        </label>
        <label className='tabRadio'>
          <input
            type='radio'
            name='chooseRadioButton'
            value='same'
            checked={selectedTypeTabOpen === 'same'}
            onChange={() => setSelectedTypeTabOpen('same')}
          />{' '}
          Same Tab
        </label>
      </div>
    </div>
  );
};
export const PaginatedList: React.FC<PaginatedListProps> = ({
  modules,
  setPageNo,
  isNextPage,
  pageNo,
  isLoading,
  courseLinkTypeSelection,
  setCourseLinkTypeSelection,
  selectedType,
  setPageNoCollaction,
  pageNoCollaction,
  setItems,
  items,
  setCurrentPage,
  currentPage,
  setCurrentItems,
  currentItems,
  response,
  setSelectedLink,
  selectedLink,
  setisApiCall,
}) => {
  const [activeId, setActiveId] = useState<number | null>(null);
  useEffect(() => {
    if (selectedLink === null) {
      setActiveId(null);
    }
  }, [selectedLink]);
  useEffect(() => {
    if (!modules) return;
    if (courseLinkTypeSelection.length > 1) {
      const lastIndex = courseLinkTypeSelection.length - 1;
      const lastValue = courseLinkTypeSelection[lastIndex];
      const prevValue = courseLinkTypeSelection[lastIndex - 1];

      if (lastValue === prevValue) {
        if (modules.length > 0) {
          setItems((prev) => [...prev, modules]);
        }
      } else {
        setItems([modules]);
        setCurrentPage(1);
      }
      setCurrentItems(modules);
    } else {
      setItems([modules]);
      setCurrentItems(modules);
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modules]);

  useEffect(() => {
    if (pageNoCollaction.includes(currentPage)) {
      setCurrentItems(items[currentPage - 1] || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);
  const totalPages = isNextPage ? pageNoCollaction.length + 1 : pageNoCollaction.length;
  const pages: number[] = [];
  const maxVisible = 3;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let endPage = Math.min(totalPages, startPage + maxVisible - 1);
  startPage = Math.max(1, endPage - maxVisible + 1);

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }
  const scrollToTop = () => {
    const listDiv = document.querySelector<HTMLDivElement>('.listTab');
    if (listDiv) {
      listDiv.scrollTop = 0;
    }
  };
  const handleDataRender = () => {
    let content;
    if (isLoading) {
      content = <TableSkeleton fromLinksModal />;
    } else if (response.statusCode !== 200) {
      content = <div>Error in fetching Course Link</div>;
    } else if (currentItems.length === 0) {
      content = (
        <em className='d-flex justify-content-center align-items-center h-100'>
          No course links found
        </em>
      );
    } else {
      content = (
        <>
          {currentItems.map((item: any, index: number) => (
            <button
              className={`listOfData ${index % 2 === 0 ? 'evenRow' : 'oddRow'} ${
                activeId === (item.id || item.page_id) ? 'active' : ''
              }`}
              key={item.id}
              onClick={() => {
                setActiveId(item.id || item.page_id);
                setSelectedLink(item);
              }}
            >
              {item.name || item.title || item.display_name || item.id}
            </button>
          ))}
        </>
      );
    }
    return content;
  };

  return (
    <div className='listTabWrapper'>
      <div className='listTab'>{handleDataRender()}</div>

      <div className='justify-content-center align-items-center pagenationWrapper'>
        <button
          className='pageSwithIcon'
          disabled={currentPage === 1 || isLoading}
          onClick={() => {
            setisApiCall(true);

            setCurrentPage(currentPage - 1);
            scrollToTop();
          }}
          data-testid='prev-button'
        >
          <LesserIcon />
        </button>

        {pages.map((p) => (
          <button
            key={p}
            className={`d-flex justify-content-center align-items-center pageButton ${
              currentPage === p ? 'active' : ''
            }`}
            onClick={() => {
              setisApiCall(true);
              setCurrentPage(p);
              if (!pageNoCollaction.includes(p)) {
                setCourseLinkTypeSelection([...courseLinkTypeSelection, selectedType]);
                setPageNoCollaction([...pageNoCollaction, p]);
                setPageNo(pageNo + 1);
              }
              scrollToTop();
            }}
          >
            {p}
          </button>
        ))}

        <button
          className='pageSwithIcon'
          disabled={totalPages === currentPage || isLoading}
          onClick={() => {
            setisApiCall(true);
            setCurrentPage(currentPage + 1);
            scrollToTop();
            if (!pageNoCollaction.includes(currentPage + 1)) {
              setCourseLinkTypeSelection([...courseLinkTypeSelection, selectedType]);
              setPageNoCollaction([...pageNoCollaction, currentPage + 1]);
              setPageNo(pageNo + 1);
            }
          }}
          data-testid='next-button'
        >
          <GreaterIcon />
        </button>
      </div>
    </div>
  );
};
